import type { TeamReferenceStory } from '@rhythmic/db/types'
import type { UseLiveQueryReturn } from '@tanstack/vue-db'
import { useLiveQuery } from '@tanstack/vue-db'
import type { MaybeRefOrGetter } from 'vue'
import { computed, toValue } from 'vue'
import { useRhythmicLogger } from '#imports'
import { getTeamReferenceStoryCollection } from '../contexts/getCollections'

export function useReferenceStoriesByTeam(
  teamId: MaybeRefOrGetter<string | null | undefined>,
): UseLiveQueryReturn<TeamReferenceStory> | undefined {
  const logger = useRhythmicLogger('useReferenceStoriesByTeam')

  const teamIdValue = computed(() => toValue(teamId))

  if (!teamIdValue.value) {
    logger.debug('Skipping reference stories query: missing team')
    return undefined
  }

  const collection = getTeamReferenceStoryCollection(teamIdValue.value)

  const query = useLiveQuery((builder) => builder.from({ t: collection }))

  return query
}
